import { getInstance } from './securitySdkConfig';

const BASE_URL = '/escrow';

const ProductsApi = {
  alreadyCreatedEscrowAccount: async () => {
    const instance = getInstance();
    const { data } = await instance.get(
      `${BASE_URL}/already-created-escrow-account`
    );

    return data;
  },

  createEscrowAccount: async (body: { accountId: string }) => {
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/create-escrow-account`, {
      ...body,
    });

    return data;
  },

  getEscrowAccount: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/escrow-account`);

    return data;
  },

  getEscrowTransactions: async (filters: advancedFilterModels.baseFilter) => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/escrow-transactions`, {
      params: filters,
    });

    return data;
  },

  getLimitSolicitations: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/limit-solicitations`);

    return data;
  },

  createLimitSolicitation: async (body: { reason: string; amount: number }) => {
    const instance = getInstance();
    const { data } = await instance.post(
      `${BASE_URL}/create-limit-solicitation`,
      {
        ...body,
      }
    );

    return data;
  },
};

export default ProductsApi;
